import script from "./table.vue?vue&type=script&setup=true&lang=js"
export * from "./table.vue?vue&type=script&setup=true&lang=js"

import "./table.vue?vue&type=style&index=0&id=0f3b5def&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3b5def"]])

export default __exports__